import React from "react";
import { useTranslation } from "react-i18next";
import { BPEStore } from "../ProductEditorStore";
import { observer } from "mobx-react-lite";
import FileUploader from "components/FileUploader";
import useFeatureFlag from "hooks/useFeatureFlag";

const ProductFiles = () => {
  const { t } = useTranslation();
  const [uploadInProgress, setUploadInProgress] = React.useState(false);
  const { isFeatureVisible } = useFeatureFlag();

  React.useEffect(() => {
    if (uploadInProgress) {
      BPEStore.setSaveValidationErrors(true);
    } else {
      BPEStore.checkSaveValidity();
    }
  }, [uploadInProgress]);

  const onRemoveFiles = (id: string) => {
    BPEStore.setFilesToRemove([...BPEStore.filesToRemove, id]);
  };

  const addToUploadFiles = (files: File[]) => {
    BPEStore.setFilesToUpload(files);
  };

  if (!isFeatureVisible("product_files")) return <></>;
  return (
    <div className="py-6 border-b border-gray-200 xl:border-b-0 xl:border-t">
      <div className="text-base font-semibold mb-3 flex items-center">
        {t("productEditor.myFiles")}
      </div>
      <FileUploader
        name="files"
        multiple
        onChange={addToUploadFiles}
        files={BPEStore.data.files}
        onRemove={onRemoveFiles}
        setInProgress={setUploadInProgress}
        maxFileSize={80 * 1024 * 1024}
      />
    </div>
  );
};

export default observer(ProductFiles);
